import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTopic from '../../../../components/newsTopic';
import ContentTitle from '../../../../components/contentTitle';
import NewsList from '../../../../components/newsList';

class FictionBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { fictionTopic, fictionTitle, fictionList0, fictionList1 },
        } = this.props;

        return (
            <div id="fictionNewsList" className={styles.fiction_box}>
                <Chip id="50083" type="struct" title="互娱小说栏标题" groupName="互娱小说栏" content={fictionTopic}>
                    <NewsTopic />
                </Chip>
                <Chip
                    id="75116"
                    type="recommend"
                    title="互娱小说栏头条"
                    groupName="互娱小说栏"
                    content={fictionTitle}
                    translate="handleNewsContentData">
                    <ContentTitle />
                </Chip>
                <Chip
                    id="75117"
                    type="recommend"
                    title="互娱小说栏新闻列表1"
                    groupName="互娱小说栏"
                    content={fictionList0}
                    translate="handleNewsContentData">
                    <NewsList isList />
                </Chip>
                <Chip
                    id="75118"
                    type="recommend"
                    title="互娱小说栏新闻列表2"
                    groupName="互娱小说栏"
                    content={fictionList1}
                    translate="handleNewsContentData">
                    <NewsList hasTitle isList />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(FictionBox);
